import { Components, Theme } from '@mui/material';

/**
 * Component overrides (i.e. global styles, default props) applied to the MUI
 * Breadcumbs to make it match the design system.
 *
 * See: https://mui.com/material-ui/api/breadcrumbs/#css
 */
export const MuiBreadcrumbs: Components<Theme>['MuiBreadcrumbs'] = {
  styleOverrides: {
    separator: ({ theme }) => ({
      margin: theme.spacing(0, 0.5),
    }),
  },
};
